import React from 'react'
import { useNavigate, useParams } from '@tanstack/react-router'
import { FieldValues, UseFormSetError } from 'react-hook-form'

import { CAPSDACTable, useFileSubmissionTableColumns, Filter } from '@/components/table'
import { FileSubmission } from '@/models/file-submission.tsx'
import SubmittedFilesCard from '@/components/file-submission/SubmittedFilesCard/SubmittedFilesCard';
import LayoutContentArea from '@/components/layout/LayoutContentArea'

export default function SubmissionsPage() {
    return (
        <LayoutContentArea 
            headingText="File Submissions"
        >
            <SubmittedFilesCard />
        </LayoutContentArea>
    );
}

export function FileSubmissionStatus<T extends FieldValues>({ data }: { data: FileSubmission[] }) {
    const params = useParams({ strict: false })
    const navigate = useNavigate()
    const columns = useFileSubmissionTableColumns(['ClientFileName', 'Errors', 'InputRecords', 'RecordTypeCode'])
    return (
        <div className="px-3 table-container">
            <CAPSDACTable data={data} columns={columns} rowClickFn={(row) => navigate({ to: '/$leaid/submissions/$submissionid', params: { leaid: params.leaid, submissionid: row.original.Id } })} />
        </div>
    )
}
